import { render, staticRenderFns } from "./DiscussChoosePeople.vue?vue&type=template&id=1636ac1a&"
import script from "./DiscussChoosePeople.vue?vue&type=script&lang=js&"
export * from "./DiscussChoosePeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports